<script>
  export let Description;
</script>

<div class="availability-description f5 poppins-font mb-3">
  {@html Description}
</div>

<style>
  .availability-description {
    :global(li),
    :global(p) {
      font-size: 16px;
      font-family: var(--poppins-font);
      line-height: 1.25;
    }

    :global(ul),
    :global(ol) {
      margin-left: 16px;
    }
  }
</style>
